var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBatteryDeepDischargeType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.713,
    height: 12.698,
    viewBox: "0 0 24.713 12.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M-918.752-719.877h-2.488v-2.807h-22.225v12.7h22.225v-2.807h2.488Zm-4.216,5.357v2.807h-18.769v-9.242h18.769v2.807h2.488v3.629h-2.488Zm-12,1.488h-5.258v-6.606h5.258Z",
    transform: "translate(943.464 722.684)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryDeepDischargeType);
export default __webpack_public_path__ + "static/media/batteryDeepDischargeType.e8ad089b.svg";
export { ForwardRef as ReactComponent };